import React, { FC, ReactNode } from 'react';

import styles from './CellData.module.scss';

type TCellDataProps = {
	children: ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

export const CellData: FC<TCellDataProps> = ({ children, ...restProps }) => {
	return (
		<div className={styles['container']} {...restProps}>
			{children}
		</div>
	);
};
